import DefaultLayout from '@/components/layout/DefaultLayout';
import { createBrowserRouter } from 'react-router-dom';
import RouterErrorBoundary from '@/components/common/RouterErrorBoundary';
import React from 'react';
import Login from '@/pages/login/Login';
import {
    PATH_BASE,
    PATH_ORDER_LIST,
    PATH_HPL_ORDER_LIST,
    PATH_HPL_QQ_ORDER_LIST,
    PATH_USER_LIST,
    PATH_MAERSK_LIST,
    PATH_LOGIN,
    PATH_MAKE_ORDER_LIST,
    PATH_MAKE_ORDER_CID,
    PATH_NAVIGATION_PAGES,
    PATH_BOOK_ACCOUNT_LIST,
    PATH_GO_ACCOUNT_LIST,
    PATH_CHECK_ACCOUNT_LIST,
    PATH_HPL_ACCOUNT_LIST,
    // PATH_MAKE_ORDER,
    // PATH_PRE_BOOKING,
    // PATH_BOOKING_MORE,
    // PATH_BOOKING,
    // PATH_CESHI_PAGES,
    PATH_SHIPPING_PAGES,
    PATH_API_LIST,
    PATH_QUERY_LIST,
    PATH_CMA_QUERY_LIST,
    PATH_MSK_API_LIST,
    PATH_HPL_LIST,
    PATH_MSC_LIST,
    PATH_ONE_LIST,
    PATH_OOCL_LIST,
    PATH_GO_LIST,
    PATH_BOOK_TEMP_LIST,
    PATH_CHECK_LIST,
    PATH_GETCMANAME_LIST,
    // PATH_CMA_LIST,
    // PATH_CESHI_LIST,
    PATH_BASE_LIST,
    PATH_SHIPPING_LIST,
    PATH_BOOK_TASK_LIST,
    PATH_BOOK_HPL_LIST,
    PATH_BOOK_TASK_API_LIST,
    PATH_REMIND_LIST,
    // PATH_ERROR_LIST,
    PATH_BOOKING_LIST,
    PATH_BOOK_ORDER_LIST,
    PATH_HPL_BOOK_ORDER_LIST,
    PATH_HPL_QQ_BOOK_ORDER_LIST,
    PATH_HPL_QQ_AUTO_BOOK_ORDER_LIST,
    PATH_ONE_BOOK_ORDER_LIST,
    PATH_ONE_ORDER_LIST,
} from '@/router/path';
import OrderList from '@/pages/OrderList';
import HplOrderList from '@/pages/HplOrderList';
import HplQQOrderList from '@/pages/HplQQOrderList';
import Landing from '@/pages/Landing';
import MakeOrder from '@/pages/MakeOrder';
import MakeOrderList from '@/pages/MakeOrderList';
import BookOrderList from '@/pages/BookOrderList';
import HplBookOrderList from '@/pages/HplBookOrderList';
import HplQQBookOrderList from '@/pages/HplQQBookOrderList';
import HplQQAutoBookOrderList from '@/pages/HplQQAutoBookOrderList';
import OneBookOrderList from '@/pages/OneBookOrderList';
import OneOrderList from '@/pages/OneOrderList';
import MakeOrderCID from '@/pages/MakeOrderCID';
import Booking from '@/pages/Booking';
import UserList from '@/pages/UserList';
import MaerskList from '@/pages/MaerskList';
import QueryAccountList from '@/pages/QueryAccountList';
import BookAccountList from '@/pages/BookAccountList';
import GoAccountList from '@/pages/GoAccountList';
import CheckAccountList from '@/pages/checkAccountList';
import NavigationPages from '@/pages/NavigationPages';
import ApiList from '@/pages/ApiList';
import QueryList from '@/pages/QueryList';
import CMAQueryList from '@/pages/CMAQueryList';
import MSKApiList from '@/pages/MskApiList';
import HplList from '@/pages/HplList';
import MscList from '@/pages/MscList';
import OneList from '@/pages/OneList';
import OoclList from '@/pages/OoclList';
import GoList from '@/pages/GoList';
import BookTempList from '@/pages/BookTempList';
import CheckList from '@/pages/CheckList';
// import CeshiList from '@/pages/aaaaceshi';
// import ShippingList from '@/pages/ShippingList';
import GetCMAName from '@/pages/GetCMAName';
// import CMAList from '@/pages/CMAList';
// import CsList from '@/pages/CsList';
import BasePortList from '@/pages/BasePortList';
import ShippingLineList from '@/pages/ShippingLineList';
import GetBookTaskList from '@/pages/GetBookTaskList';
import GetBookHplTaskList from '@/pages/GetBookHplTaskList';
import GetBookTaskApiList from '@/pages/GetBookTaskApiList';
import GetRemindList from '@/pages/GetRemind';
// import GeterrorList from '@/pages/GeterrorList';
import BookingStartList from '@/pages/BookingStartList';
import HplAccountList from '@/pages/HplAccountList';

export const ROUTES = [
    {
        path: '/',
        errorElement: <RouterErrorBoundary />,
        children: [
            { path: PATH_LOGIN, element: <Login /> },
            {
                path: PATH_BASE,
                element: <DefaultLayout />,
                children: [
                    {
                        path: PATH_MAERSK_LIST,
                        element: <MaerskList></MaerskList>,
                    },
                    {
                        path: PATH_USER_LIST,
                        element: <UserList></UserList>,
                    },
                    {
                        path: PATH_ORDER_LIST,
                        element: <OrderList></OrderList>,
                    },
                    {
                        path: PATH_HPL_ORDER_LIST,
                        element: <HplOrderList></HplOrderList>,
                    },
                    {
                        path: PATH_HPL_QQ_ORDER_LIST,
                        element: <HplQQOrderList></HplQQOrderList>,
                    },
                    {
                        path: PATH_MAKE_ORDER_LIST,
                        element: <MakeOrderList></MakeOrderList>,
                    },
                    {
                        path: PATH_BOOK_ORDER_LIST,
                        element: <BookOrderList></BookOrderList>,
                    },
                    {
                        path: PATH_HPL_BOOK_ORDER_LIST,
                        element: <HplBookOrderList></HplBookOrderList>,
                    },
                    {
                        path: PATH_HPL_QQ_BOOK_ORDER_LIST,
                        element: <HplQQBookOrderList></HplQQBookOrderList>,
                    },
                    {
                        path: PATH_HPL_QQ_AUTO_BOOK_ORDER_LIST,
                        element: <HplQQAutoBookOrderList></HplQQAutoBookOrderList>,
                    },
                    {
                        path: PATH_ONE_BOOK_ORDER_LIST,
                        element: <OneBookOrderList></OneBookOrderList>,
                    },
                    {
                        path: PATH_ONE_ORDER_LIST,
                        element: <OneOrderList></OneOrderList>,
                    },
                    {
                        path: PATH_MAKE_ORDER_CID,
                        element: <MakeOrderCID></MakeOrderCID>,
                    },
                    {
                        path: PATH_NAVIGATION_PAGES,
                        element: <NavigationPages></NavigationPages>,
                    },
                    {
                        path: PATH_BOOK_ACCOUNT_LIST,
                        element: <BookAccountList></BookAccountList>,
                    },
                    {
                        path: PATH_GO_ACCOUNT_LIST,
                        element: <GoAccountList></GoAccountList>,
                    },
                    {
                        path: PATH_CHECK_ACCOUNT_LIST,
                        element: <CheckAccountList></CheckAccountList>,
                    },
                    {
                        path: PATH_HPL_ACCOUNT_LIST,
                        element: <HplAccountList></HplAccountList>,
                    },
                    // {
                    //     path: PATH_CESHI_PAGES,
                    //     element: <CeshiList></CeshiList>,
                    // },
                    // {
                    //     path: PATH_SHIPPING_PAGES,
                    //     element: <ShippingList></ShippingList>,
                    // },
                    {
                        path: PATH_API_LIST,
                        element: <ApiList></ApiList>,
                    },
                    {
                        path: PATH_CHECK_LIST,
                        element: <CheckList></CheckList>,
                    },
                    {
                        path: PATH_QUERY_LIST,
                        element: <QueryList></QueryList>,
                    },
                    {
                        path: PATH_CMA_QUERY_LIST,
                        element: <CMAQueryList></CMAQueryList>,
                    },
                    {
                        path: PATH_MSK_API_LIST,
                        element: <MSKApiList></MSKApiList>,
                    },
                    {
                        path: PATH_HPL_LIST,
                        element: <HplList></HplList>,
                    },
                    {
                        path: PATH_MSC_LIST,
                        element: <MscList></MscList>,
                    },
                    {
                        path: PATH_ONE_LIST,
                        element: <OneList></OneList>,
                    },
                    {
                        path: PATH_OOCL_LIST,
                        element: <OoclList></OoclList>,
                    },
                    {
                        path: PATH_GO_LIST,
                        element: <GoList></GoList>,
                    },
                    {
                        path: PATH_BOOK_TEMP_LIST,
                        element: <BookTempList></BookTempList>,
                    },
                    {
                        path: PATH_BOOKING_LIST,
                        element: <BookingStartList></BookingStartList>,
                    },
                    {
                        path: PATH_GETCMANAME_LIST,
                        element: <GetCMAName></GetCMAName>,
                    },
                    // {
                    //     path: PATH_CMA_LIST,
                    //     element: <CMAList></CMAList>,
                    // },
                    // {
                    //     path: PATH_CESHI_LIST,
                    //     element: <CsList></CsList>,
                    // },
                    {
                        path: PATH_BASE_LIST,
                        element: <BasePortList></BasePortList>,
                    },
                    {
                        path: PATH_SHIPPING_LIST,
                        element: <ShippingLineList></ShippingLineList>,
                    },
                    {
                        path: PATH_BOOK_TASK_LIST,
                        element: <GetBookTaskList></GetBookTaskList>,
                    },
                    {
                        path: PATH_BOOK_HPL_LIST,
                        element: <GetBookHplTaskList></GetBookHplTaskList>,
                    },
                    {
                        path: PATH_BOOK_TASK_API_LIST,
                        element: <GetBookTaskApiList></GetBookTaskApiList>,
                    },
                    {
                        path: PATH_REMIND_LIST,
                        element: <GetRemindList></GetRemindList>,
                    },
                    // {
                    //     path: PATH_ERROR_LIST,
                    //     element: <GeterrorList></GeterrorList>,
                    // },

                    // {
                    //     path: PATH_MAKE_ORDER,
                    //     element: <MakeOrder></MakeOrder>,
                    // },
                    // {
                    //     path: PATH_BOOKING,
                    //     element: <Booking formSubmitEvent="init_process" cacheKey="booking_form_cache" />,
                    // },
                    // {
                    //     path: PATH_PRE_BOOKING,
                    //     element: <Booking formSubmitEvent="init_init_process" cacheKey="pre_booking_form_cache" />,
                    // },
                    // {
                    //     path: PATH_BOOKING_MORE,
                    //     element: <Booking formSubmitEvent="load_init_process" cacheKey="booking_more_form_cache" />,
                    // },
                    {
                        path: '*',
                        element: <RouterErrorBoundary status={404} />,
                    },
                ],
            },
        ],
    },
    {
        index: true,
        element: <Landing />,
    },
];

// 路由配置
export const ROUTERS = createBrowserRouter(ROUTES);
